import { Separator } from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'
import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-bottom: 24px;
  max-width: 448px;

  ${breakpoint('lg')`
    margin-bottom: 0px;
  `}
`

export const ItemWrapper = styled.div`
  display: flex;
  gap: 16px;

  & + & {
    margin-top: 16px;
  }

  [role='img'] {
    /* Align the icon with the text */
    margin-top: 2px; /* stylelint-disable-line scales/space */

    width: 17px;
    height: 17px;
    flex-shrink: 0;
  }
`

export const Divider = styled(Separator)`
  width: 160px;
  margin-bottom: 26px; /* stylelint-disable-line scales/space */
`
